import { useDeleteBrand } from "http-hooks/brand/useBrand";
import DeleteConfirmation from "components/ui/DeleteConfirmation";

export default function DeleteBrand({ id, onClose, setOpen }) {
  const { mutateAsync, isPending } = useDeleteBrand();

  const handleDelete = async () => {
    try {
      await mutateAsync(id);
      onClose();
    } catch (error) {
      // Error toast already shown by service
      console.error("Delete failed:", error);
    }
  };

  return (
    <DeleteConfirmation
      title="Delete Brand"
      description="Are you sure you want to delete this brand? This brand will be permanently removed. This action cannot be undone."
      onDelete={handleDelete}
      onClose={onClose}
      isLoading={isPending}
    />
  );
}
